
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { length, item, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { fold } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { join, substring, split } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { truncate, map, item as item_1, equalsWith } from "../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { min } from "../fable_modules/fable-library-js.5.0.0-rc.2/Double.js";
import React from "react";
import { reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";

export class ParticipantColor extends Record {
    constructor(Background, Ink) {
        super();
        this.Background = Background;
        this.Ink = Ink;
    }
}

export function ParticipantColor_$reflection() {
    return record_type("Components.Avatar.ParticipantColor", [], ParticipantColor, () => [["Background", string_type], ["Ink", string_type]]);
}

const palette = ofArray([new ParticipantColor("#15BFA0", "#0B7A67"), new ParticipantColor("#4A7BD0", "#2F5BA8"), new ParticipantColor("#9B5DC4", "#7A3FA3"), new ParticipantColor("#D0763A", "#A3561F"), new ParticipantColor("#C94F7C", "#A03260"), new ParticipantColor("#3F9E5B", "#2A7A42"), new ParticipantColor("#5B8FB9", "#3C6A8F"), new ParticipantColor("#B0892E", "#866618")]);

export function participantColor(id) {
    return item(fold((acc, c) => ((((acc * 31) + ~~c.charCodeAt(0)) % 1000003) | 0), 7, id.split("")) % length(palette), palette);
}

export function initials(name) {
    const parts = split(name, [" "], undefined, 1);
    let letters;
    if (!equalsWith((x, y) => (x === y), parts, defaultOf()) && (parts.length === 0)) {
        letters = "";
    }
    else if (!equalsWith((x_1, y_1) => (x_1 === y_1), parts, defaultOf()) && (parts.length === 1)) {
        const single = item_1(0, parts);
        letters = substring(single, 0, min(2, single.length));
    }
    else {
        letters = join("", map((part) => substring(part, 0, 1), truncate(2, parts)));
    }
    if (letters === "") {
        return "?";
    }
    else {
        return letters.toUpperCase();
    }
}

export function Avatar(props) {
    return reactElement("div", {
        className: join(" ", ["rounded-full", "text-white", "text-[12px]", "font-bold", "flex", "items-center", "justify-center", "shrink-0"]),
        style: {
            width: props.Size,
            height: props.Size,
            backgroundColor: participantColor(props.Id).Background,
        },
        title: props.Name,
        children: initials(props.Name),
    });
}

